import styled from "styled-components";

export const AboutSpiffy = styled.div`
  .lp-intro {
    flex: 0 0 40rem;
  }
  @media only screen and (max-width: 600px) {
    .lp-intro {
      flex: 0 0 100vw;
    }
  }
`;
